import clsx from 'clsx'
import { FolderOpenDot } from 'lucide-react'

import { type SingleSelectedValueFilter } from 'components/brokers/types'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from 'components/ui/select'
import { AdminEmployerBankOnboardingStatus } from 'utils/web_api.schemas'

const EmployerBankOnboardingStatusFilter = ({
  selectValue,
  selectedValue,
}: SingleSelectedValueFilter) => {
  const bankOnboardingStatusOptions = [
    {
      label: 'Passing',
      value: AdminEmployerBankOnboardingStatus.passing,
    },
    {
      label: 'Failing',
      value: AdminEmployerBankOnboardingStatus.failing,
    },
    {
      label: 'Pending',
      value: AdminEmployerBankOnboardingStatus.pending,
    },
    { label: 'None', value: AdminEmployerBankOnboardingStatus.none },
  ]

  return (
    <div
      style={{ width: '300px' }}
      className={clsx({
        'rounded-md bg-slate-50 flex items-center justify-between px-2 py-1 text-sm':
          true,
        'text-thatch-purple': selectedValue,
        'text-ds-text-secondary': !selectedValue,
      })}
    >
      <div className='flex items-center gap-2'>
        <FolderOpenDot size={16} />
        <span>Bank Requirements Status</span>
      </div>
      <div className='ml-auto flex items-center justify-between shrink-0'>
        <Select value={selectedValue} onValueChange={selectValue}>
          <SelectTrigger className='h-8 w-[140px]'>
            <SelectValue placeholder='Select status...' />
          </SelectTrigger>
          <SelectContent>
            {bankOnboardingStatusOptions.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  )
}

export default EmployerBankOnboardingStatusFilter
